import { MenuOptionGroup } from '@chakra-ui/react'

export default MenuOptionGroup
